import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import { HiOutlineBars3 } from 'react-icons/hi2';
import useSiteBootstrap from '../hooks/useSiteBootstrap';
import '../styles/layout-shell.css';

export default function MainNavbar() {
  const site = useSiteBootstrap();
  const menuPages = site?.menu_pages || [];
  const logoUrl = site?.settings?.logo_url || '';
  const siteName = site?.settings?.site_name || 'Trainable AI Agent SaaS';
  const isBootstrapping = site === null;

  return (
    <Navbar expand="lg" className="main-navbar-shell" collapseOnSelect>
      <Container>
        <Navbar.Brand as={Link} to="/" className="main-navbar-shell__brand">
          {isBootstrapping || !logoUrl ? (
            <span className="main-navbar-shell__logo-skeleton" aria-hidden="true" />
          ) : (
            <img
              src={logoUrl}
              alt={siteName}
              className="main-navbar-shell__logo"
            />
          )}
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="main-nav"
          className="main-navbar-shell__toggle"
        >
          <HiOutlineBars3 className="main-navbar-shell__toggle-icon" />
        </Navbar.Toggle>

        <Navbar.Collapse id="main-nav" className="main-navbar-shell__collapse">
          <Nav className="main-navbar-shell__nav ms-auto">
            <Nav.Link as={NavLink} to="/" end>
              Home
            </Nav.Link>

            <Nav.Link as={NavLink} to="/pricing">
              Pricing
            </Nav.Link>

            <Nav.Link as={NavLink} to="/chat">
              Chat
            </Nav.Link>

            {menuPages.map((p) => (
              <Nav.Link as={NavLink} to={`/pages/${p.slug}`} key={p.id}>
                {p.title}
              </Nav.Link>
            ))}

            <Nav.Link as={NavLink} to="/login">
              Login
            </Nav.Link>

            <Nav.Link as={NavLink} to="/signup" className="nav-link--cta">
              Sign up
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
